export class FinanciamentoTaxa {
  public id!: number;
  public prazoInicio!: number;
  public prazoFim!: number;
  public taxa!: number;
  public percentComissao!: number;
}